module.exports = __webpack_public_path__ + "img/consulting-light.8a38e652.png";